import * as yup from 'yup';

yup.addMethod(yup.string, 'select', function () {
  return this.test('select', function () {
    const { path, createError } = this;
    const value = document.getElementsByName(path)[0].value;
    return new Promise((resolve, reject) => {
      if (value) {
        resolve(true);
      } else {
        reject(
          createError({ path, message: 'field is required', type: 'required' })
        );
      }
    });
  });
});

const schema = yup.object().shape({
  name: yup
    .string()
    .required()
    .trim(),
  department: yup
    .string()
    .required()
    .trim(),
  icon: yup.string().select(),
  description: yup
    .string()
    .required()
    .trim()
});

export default schema;
